module.exports = __webpack_public_path__ + "static/media/info_caution.41bc2d61.png";